<template>
<table class="data large fact_check claims_table">
    <thead>
        <tr class="header">
            <th class="source"><span>Fact-Checker</span></th>
            <th><span>Fact Checker(s)</span></th>
            <th>
                <span>Fact</span>
                <br/>
                <span>Opinion</span>
                <br/>
                <span>Projection</span>
            </th>
            <th class="source"><span>Author of Claim</span></th>
            <th><span>Outlet Verdict</span></th>
            <!-- <th class="source"><span>Sources Used</span></th> -->
        </tr>
    </thead>
    <template v-if="loading"  >
        <tbody v-for="(num) in placeHolderNumber" :key="num" >
            <tr>
                <td class="placeholder-glow" >
                    <span class="placeholder"></span>
                </td>
                <td class="placeholder-glow" >
                    <span class="placeholder"></span>
                </td>
                <td class="placeholder-glow" >
                    <span class="placeholder"></span>
                </td>
                <td class="placeholder-glow" >
                    <span class="placeholder"></span>
                </td>
                <td class="placeholder-glow" >
                    <span class="placeholder"></span>
                </td>
            </tr>
            <tr>
                <td colspan="5" class="placeholder-glow" >
                    <span class="placeholder"></span>
                </td>
            </tr>
        </tbody>
    </template>
    <tbody v-else 
        v-for="(claim, claim_index) in claims" 
        :key="claim_index" >
        <tr>
            <td class="fc_source" rowspan="1">
                
                <!-- <router-link v-if="claim.fact_check_org_link" :to="claim.fact_check_org_link" >{{claim.fact_check_org}}</router-link> -->
                <!-- <a v-else target="_blank">{{claim.fact_check_org}}</a> -->

                <router-link :to="{name: 'organization_page', params: {'org': claim.fact_check_org_slug}}" >{{claim.fact_check_org}}</router-link>

                <div class="date">
                    ({{ claim.publish_date | formatFactCheckDate }})
                </div>
            </td>
            <td class="source">
                <span v-for="(checker, x) in claim.fact_check_persons" 
                    :key="`${x}-fact-checker`" > 
                        <router-link 
                            v-if="displayLinks" 
                            :to="{name: '/fact_check_review/search', query: {opts: createQuery({fc_authors: [claim.fact_check_persons_ids[x]]})}, }" 
                            >{{checker}}{{  (x+1) < claim.fact_check_persons.length ? ", " : ""}}</router-link>
                        <span v-else >{{checker}}{{  (x+1) < claim.fact_check_persons.length ? ", " : ""}}</span>
                    </span>
            </td>
            <td>{{ claim.opinion_or_fact | claimFactOpinionProjection }}</td>
            <td class="source">
                <div v-for="(s, y) in claim.sources_of_claim" :key="`${y}-source-key`" >
                    <router-link 
                        v-if="displayLinks" 
                        :to="{name: 'search', query: {opts: createQuery({cs: [s.source_id]})}, }" 
                        >{{s.source_name}}</router-link>
                    <a v-else :href="valid_url(s.source_url)" target="_blank">{{s.source_name}}</a>
                </div>
            </td>
            <td class="fc_verdict" >
                <router-link 
                    v-if="displayLinks" 
                    :to="{name: 'search', query: {opts: createQuery({v: [claim.oulet_verdict_id]})}, }" 
                    v-html="outletVerdict(claim)" 
                    ></router-link>
                <span 
                    v-else 
                    v-html="outletVerdict(claim)" 
                    ></span>
            </td>
            <!-- <td class="source">
                <div class="verification">
                    <a href="http://businessinsider.com" target="_blank">Business Insider</a>
                </div>
                <div class="verification">
                    <a target="_blank">Glenn Youngkin</a>
                </div>
                <div class="verification">
                    <a target="_blank">Matt Wolking</a>
                </div>
                <div class="verification">
                    <a target="_blank">Renzo Olivari</a>
                </div>
                <div class="verification">
                    <a target="_blank">U.S. Export-Import Bank</a>
                </div><span></span>
                <div class="expand">
                    <span><img alt="Show All" class="arrow display_arrow" src="https://www.realclearpolitics.com/fact_check_review/down_arrow.png"> Show All <img alt="Show All" class="arrow display_arrow" src="https://www.realclearpolitics.com/fact_check_review/down_arrow.png"></span>
                </div>
            </td> -->
        </tr>
        <tr>
            <td class="summary" colspan="5">
                <a :href="valid_url(claim.fact_check_url)"  target="_blank"><b>Claim: </b>{{claim.claim_summary}}</a>
            </td>
        </tr>
        <tr v-if="(claim.category_name !== null && claim.category_name !== '') || claim.sources_of_claim.length > 0">
            <td class="summary" colspan="2">
                <template v-if="(claim.category_name !== null && claim.category_name !== '')" >
                    <b>Claim Subject:</b> 
                    <router-link 
                        v-if="displayLinks" 
                        :to="{name: 'search_index', query: {opts: createQuery({ct: [claim.category_id]})}, }" 
                        >{{claim.category_name}}</router-link>
                    <span v-else >{{claim.category_name}}</span>
                </template>
            </td>
            <td class="summary" colspan="3">
                <template v-if="claim.sources_of_claim.length > 0" >
                    <b>Claim Author Category:</b>
                    <span v-for="(source, source_type_index) in claim.sources_of_claim" :key="`${source_type_index}-source`"
                        >
                        <router-link 
                            v-if="displayLinks" 
                            :to="{name: 'search_index', query: {opts: createQuery({cst: [{id: parseInt(source.claim_source_type_id)}]})}, }" 
                            >{{source.claim_source_type_name}}{{ (source_type_index+1) < claim.sources_of_claim.length ? ", " : ""}}</router-link>
                        <span v-else >{{source.claim_source_type_name}}{{ (source_type_index+1) < claim.sources_of_claim.length ? ", " : ""}}</span>
                    </span>
                </template>
            </td>
        </tr>
        <tr v-if="claim.tags.length > 0" >
            <td class="summary" colspan="5">
                <b>Tags:</b>
                <span v-for="(tag, tag_index) in claim.tags" :key="`${tag_index}-tag`"
                    >
                    <router-link 
                        v-if="displayLinks" 
                        :to="{name: 'search_index', query: {opts: createQuery({tags: [parseInt(tag.id)] })}, }" 
                        >{{tag.name}}{{ (tag_index+1) < claim.tags.length ? ", " : ""}}</router-link>
                    <span v-else>{{tag.name}}{{ (tag_index+1) < claim.tags.length ? ", " : ""}}</span>
                </span>
            </td>
        </tr>
    </tbody>
</table>
</template>

<script>
export default {
    name: 'claims-table',
    props: {
        claims: {
            type: Array,
            required: true,
        },
        loading: {
            default: false,
            required: false,
        },
        placeHolderNumber: {
            default: 20,
            required: false,
        },
        displayLinks: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
        };
    },
    filters: {
        claimFactOpinionProjection(value){
            value = parseInt(value);
            if(value == 0){
                return 'Opinion';
            }
            if(value == 1){
                return 'Fact';
            }
            if(value == 2){
                return 'Projection';
            }
        },
        formatFactCheckDate(publish_date){
            return dayjs(publish_date).format("MM.DD.YYYY");
        },
    },
    methods: {

        valid_url(str) {

            if (!str) {
                return null;
            }

            if (str.split("://").length > 1) {
                return str;
            } else if (str.split("www.").length > 1) {
                return 'http://' + str;
            } else {
                return 'http://' + str;
            }
        },

        outletVerdict(claim) {

            var output = (claim.outlet_verdict !== null) ? claim.outlet_verdict.toLowerCase() : '';

            if (claim.misleading > 0) {
                output += '<br />(Misleading)';
            }
            if (claim.lack_of_evidence > 0) {
                output += '<br />(Lack of Evidence)';
            }

            return output;
        }
    },
}
</script>

<style lang="scss">
#polling-data-rcp {
    table.data.large.claims_table{
        span.placeholder {
            display: block;
            width: 90%;
        }

        thead{
            .header{
                th{
                    @media screen and (max-width: 767px) {
                            
                        &{
                            font-family: 'ROBOTO', sans-serif;
                            -webkit-text-size-adjust: none !important;
                            font-size: 12px;
                            border-collapse: separate;
                            border-spacing: 0;
                            text-align: left !important;
                            padding-left: 2px !important;
                            position: relative;
                            padding: 3px 0;
                            word-break: normal;
                            word-wrap: break-word;
                            background-color: #000000;
                            border-left: 1px solid #070707;
                            color: #000;
                            border-bottom: 1px solid #ccc;
                            width: 15%;
                        }
                    }

                    span{

                        @media screen and (max-width: 767px) {
                            
                            &{
                                font-family: 'ROBOTO', sans-serif;
                                -webkit-text-size-adjust: none !important;
                                font-size: 12px;
                                border-collapse: separate;
                                border-spacing: 0;
                                word-break: normal;
                                word-wrap: break-word;
                                color: #fff;
                                text-align: center;
                                vertical-align: middle;
                                left: initial;
                                width: initial;
                                transform: initial;
                                transform-origin: initial;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>